//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

export default {
	name: 'Pagination',
	data() {
		return {
			pageCount: null
		}
	},
	watch: {
		filteredListings: function() {
			this.setPageCount();
		}
	},
	computed: {
		...mapGetters(["listingsData", "currentPage", "filteredListings"]),
		middlePagesShowing() {
			let middlePageArray = [];
			for (let i = 2; i < this.pageCount; i++) {
				middlePageArray.push(i);
			}
			if (middlePageArray.length > 3) {
				if (this.currentPage < 3) {
					middlePageArray = middlePageArray.slice(0, 2);
				} else if (this.currentPage === this.pageCount || this.currentPage === this.pageCount - 1) {
					middlePageArray = middlePageArray.slice(-2)
				} else {
					let currentIndex = middlePageArray.indexOf(this.currentPage);
					middlePageArray = middlePageArray.slice(currentIndex -1, currentIndex + 2);
				}
			}
			return middlePageArray
		},
	},
	methods: {
		...mapActions(["changePage"]),
		setPageCount() {
			if (this.filteredListings === null) {
				this.pageCount = Math.ceil(this.listingsData.listings.length / parseInt(this.$root.listingCount));
			} else {
				this.pageCount = Math.ceil(this.filteredListings.length / parseInt(this.$root.listingCount));
			}
		},
		setCurrentPage(e, pageNumber) {
			let listingAppContainer = e.target.closest(".listing-app");
			if (pageNumber > 0 && pageNumber <= this.pageCount && pageNumber !== this.currentPage) {
				listingAppContainer.scrollIntoView()
				this.changePage(pageNumber);
			}
		},
		showEllipses(num) {
			return (!this.middlePagesShowing.includes(num) && this.middlePagesShowing.length > 0 && this.pageCount > 5);
		}
	},
	mounted() {
		this.setPageCount();
	},
	updated() {
		this.setPageCount();
	}
}
